import cn from 'bem-cn';

import { Stack } from '../UI';

import { ChallengeInfoHeaderSkeleton } from './ChallengeInfoHeader';
import { ChallengeInfoBodySkeleton } from './ChallengeInfoBody';
import './ChallengeInfo.scss';

const b = cn('challenge-info');

export const ChallengeInfoSkeleton = () => {
    return (
        <Stack className={b()}>
            <ChallengeInfoHeaderSkeleton />
            <ChallengeInfoBodySkeleton />
        </Stack>
    );
};
